import styled from 'styled-components';

const Container = styled.div`
  margin: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  color: #553e65;

  strong {
    font-weight: 600;
  }

  img {
    margin: 20px;
  }

  p {
    color: #381451;
    font-size: 20px;
    font-weight: 600;
    padding-bottom: 20px;
  }

  span {
    width: 270px;
  }
`;

export default Container;
